import { Redirect, useLocation } from 'react-router-dom';

import { useAuth } from '../../hooks';
import { ROUTE_QUERY_PARAM } from './const';
import { buildConversationPath } from './orgRouteUtils';

const ConversationExternalDeepLinkRedirect = () => {
  const location = useLocation();
  const { orgs, organization_id: selectedOrg, isLoading } = useAuth();

  const searchParams = new URLSearchParams(location.search);
  const queryOrgId = searchParams.get(ROUTE_QUERY_PARAM.ORGANIZATION_ID);
  const conversationId = searchParams.get(ROUTE_QUERY_PARAM.CONVERSATION_ID);

  if (isLoading) return null;

  const isKnownOrg = queryOrgId && orgs.some(o => o.id === queryOrgId);
  const resolvedOrgId = isKnownOrg
    ? queryOrgId
    : (selectedOrg ?? orgs[0]?.id ?? '');

  if (!resolvedOrgId) return null;

  searchParams.delete(ROUTE_QUERY_PARAM.ORGANIZATION_ID);
  if (conversationId) {
    searchParams.delete(ROUTE_QUERY_PARAM.CONVERSATION_ID);
  }

  const remainingSearch = searchParams.toString();
  const search = remainingSearch ? `?${remainingSearch}` : '';

  const pathname = conversationId
    ? buildConversationPath(resolvedOrgId, conversationId)
    : buildConversationPath(resolvedOrgId);

  return <Redirect to={{ pathname, search }} />;
};

export default ConversationExternalDeepLinkRedirect;
